<template>
  <div>
    <div v-if="familyListF" class="person_layout_style">
      <el-page-header @back="goBack" class="pc_hide_style"> </el-page-header>
      <div class="person_style">家庭成员</div>
      <div
        v-for="item in userFamilyList"
        :key="item.familyId"
        class="fam_style"
      >
        <el-descriptions :column="1" :colon="false" border>
          <el-descriptions-item label="姓">{{
            item.firstName
          }}</el-descriptions-item>
          <el-descriptions-item label="名">{{
            item.lastName
          }}</el-descriptions-item>
          <!-- <el-descriptions-item label="出生年月日">{{
          item.born
        }}</el-descriptions-item> -->
          <el-descriptions-item label="性别">{{
            item.sex
          }}</el-descriptions-item>
          <el-descriptions-item label="身份证号">{{
            item.cardId
          }}</el-descriptions-item>
          <el-descriptions-item label="身高">{{
            item.height
          }}</el-descriptions-item>
          <el-descriptions-item label="体重">{{
            item.weight
          }}</el-descriptions-item>
          <el-descriptions-item label="疾病">{{
            item.disease
          }}</el-descriptions-item>
          <el-descriptions-item label="免疫力">{{
            item.immunity
          }}</el-descriptions-item>
          <el-descriptions-item label="过敏">{{
            item.allergy
          }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="family_add_style" @click="familyAddClick">添加</div>
    </div>
    <div v-else class="person_layout_style1">
      <el-page-header @back="goBack" class="pc_hide_style"> </el-page-header>
      <div class="person_style">家庭成员</div>
      <div class="name_style">
        <div>
          <el-input placeholder="" v-model="firstName" class="first_style">
            <template slot="prepend">姓</template>
          </el-input>
        </div>
        <div>
          <el-input placeholder="" v-model="lastName" class="last_style">
            <template slot="prepend">名</template>
          </el-input>
        </div>
      </div>
      <div>
        <!-- <div>
          <div>出生年月日</div>
          <el-date-picker v-model="born" type="date" placeholder="选择日期">
          </el-date-picker>
        </div> -->
        <div>
          <el-input placeholder="" v-model="sex" class="first_style">
            <template slot="prepend">性别</template>
          </el-input>
        </div>
        <div>
          <el-input placeholder="" v-model="cardId" class="card_id_last_style">
            <template slot="prepend">
              <div>身份证号</div>
              <div>(通关需要)</div>
            </template>
          </el-input>
        </div>
      </div>
      <div class="body_style">体质情报</div>
      <div class="height_style">
        <div>
          <el-input placeholder="" v-model="height" class="first_style">
            <template slot="prepend">身高</template>
          </el-input>
        </div>
        <div>
          <el-input placeholder="" v-model="weight" class="last_style">
            <template slot="prepend">体重</template>
          </el-input>
        </div>
      </div>
      <div class="disease_style">
        <div>
          <el-input placeholder="" v-model="disease" class="first_style">
            <template slot="prepend">现有症状疾病</template>
          </el-input>
        </div>
        <div>
          <el-input
            placeholder=""
            v-model="immunity"
            class="immunity_last_style"
          >
            <template slot="prepend">免疫力如何</template>
          </el-input>
        </div>
        <div>
          <el-input placeholder="" v-model="allergy" class="last_style">
            <template slot="prepend">过敏成分</template>
          </el-input>
        </div>
      </div>
      <div class="family_style" @click="familyInsert">保存</div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
  computed: {
    ...mapState(["cgmUserVO"]),
  },
  data() {
    return {
      firstName: null,
      lastName: null,
      born: null,
      sex: null,
      cardId: null,
      height: null,
      weight: null,
      disease: null,
      immunity: null,
      allergy: null,
      userFamilyList: [],
      familyListF: false,
    };
  },
  mounted() {
    // this.getFamilyList();
  },
  methods: {
    goBack() {
      // this.$router.back()
      this.$router.push({
        path: "/menu",
      });
    },
    familyAddClick() {
      this.familyListF = false;
    },
    getFamilyList() {
      let userId = JSON.parse(this.cgmUserVO).userId;
      this.axios
        .get("/cgmFamily/listByUserId", {
          params: {
            userId,
          },
        })
        .then((res) => {
          if (res.data.code == 200 && res.data.data.length > 0) {
            this.userFamilyList = res.data.data;
            this.familyListF = true;
          }
        });
    },
    familyInsert() {
      if (this.firstName == null || this.firstName == "") {
        this.$message({
          type: "error",
          message: "请输入姓！",
        });
        return;
      }
      if (this.lastName == null || this.lastName == "") {
        this.$message({
          type: "error",
          message: "请输入名！",
        });
        return;
      }
      if (this.sex == null || this.sex == "") {
        this.$message({
          type: "error",
          message: "请输入性别！",
        });
        return;
      }
      if (this.cardId == null || this.cardId == "") {
        this.$message({
          type: "error",
          message: "请输入身份证号！",
        });
        return;
      }
      if (this.height == null || this.height == "") {
        this.$message({
          type: "error",
          message: "请输入身高！",
        });
        return;
      }
      if (this.weight == null || this.weight == "") {
        this.$message({
          type: "error",
          message: "请输入体重！",
        });
        return;
      }
      let userId = JSON.parse(this.cgmUserVO).userId;
      this.axios
        .post("/cgmFamily/save", {
          userId,
          firstName: this.firstName,
          lastName: this.lastName,
          born: this.born,
          sex: this.sex,
          cardId: this.cardId,
          height: this.height,
          weight: this.weight,
          disease: this.disease,
          immunity: this.immunity,
          allergy: this.allergy,
        })
        .then((res) => {
          this.getFamilyList();
          this.$message({ type: "success", message: "添加成功！" });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@media (max-width:768px) {
  .person_layout_style {
    margin: 20px;
    width: unset !important;
  }
  .person_layout_style1 {
    margin: 20px;
    width: unset !important;
  }
}
@media (min-width:768px) {
  .pc_hide_style {
    display: none;
  }
}
.disease_style {
  margin-bottom: 20px;
}
.height_style {
  margin-bottom: 20px;
}
::v-deep .el-input__inner {
  border-left: hidden;
  text-align: right;
  height: 50px;
  line-height: 50px;
}
::v-deep .card_id_last_style .el-input__inner {
  border-left: hidden;
  text-align: right;
  height: 70px;
  line-height: 70px;
}
::v-deep .el-input-group__prepend {
  background-color: transparent;
}
::v-deep .first_style .el-input-group__prepend {
  border-bottom-left-radius: 0px;
  border-top-left-radius: 8px;
  border-bottom: hidden;
}
::v-deep .last_style .el-input-group__prepend {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 8px;
}
::v-deep .card_id_last_style .el-input-group__prepend {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 8px;
}
::v-deep .immunity_last_style .el-input-group__prepend {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
::v-deep .first_style .el-input__inner {
  border-bottom-right-radius: 0px;
  border-top-right-radius: 8px;
  border-bottom: hidden;
}
::v-deep .last_style .el-input__inner {
  border-bottom-right-radius: 8px;
  border-top-right-radius: 0px;
}
::v-deep .card_id_last_style .el-input__inner {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 8px;
}
::v-deep .immunity_last_style .el-input__inner {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
::v-deep .el-input__inner:hover {
  border-color: #dcdfe6;
}
::v-deep .el-input__inner:focus {
  border-color: #dcdfe6;
}
.family_style {
  width: 162px;
  height: 42px;
  border-radius: 21px;
  background: #e0000f;
  color: #fff;
  line-height: 42px;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
}
.family_add_style {
  width: 162px;
  height: 42px;
  border-radius: 21px;
  background: #e0000f;
  color: #fff;
  line-height: 42px;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
  margin-top: 20px;
}
.body_style {
  font-size: 22px;
  color: #202f3b;
  font-weight: bold;
  margin: 25px 0;
}
.name_style {
  // border-radius: 8px;
  // padding-left: 17px;
  // border: 1px solid #dcdde1;
  // margin-bottom: 20px;
  // background: #fff;
  margin-bottom: 20px;
}
.person_style {
  font-size: 22px;
  color: #202f3b;
  font-weight: bold;
  margin-bottom: 25px;
}
.person_layout_style {
  width: 345px;
}
.person_layout_style1 {
  width: 345px;
}
.fam_style {
  margin-bottom: 20px;
}
</style>